import { classes, icons } from '@portal/components'
import { ComponentProps } from 'react'

const { Empty } = icons

type Props = {
  /** Message to display underneath the icon */
  message: string
  /** Optional class name for the container element. */
  className?: string
  /** Optional props to pass to the icon. */
  iconProps?: ComponentProps<typeof Empty>
  /** Optional boolean to show/hide the icon. */
  icon?: boolean
}
export default function EmptyState({
  message,
  className,
  iconProps,
  icon = true,
}: Props) {
  return (
    <div
      className={classes(
        'flex flex-1 flex-col items-center gap-3 text-center',
        className,
      )}
    >
      {icon && <Empty className="h-10 w-10" {...iconProps} />}
      <p className="font-medium text-foreground-subtle">{message}</p>
    </div>
  )
}
